import React from 'react';
import { Files, Heading, Link, Title, FileCards, FirstFile, TopFile, BottomFile, First } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';

const CustomerFilesLoading: React.FC = () => {
  return (
    <Files>
      <Heading>
        <Title>Document & Files</Title>
        <Link>+ Add</Link>
      </Heading>
      <FileCards>
        <FirstFile>
          <TopFile>
            <SVGIcon name='file-loading-icon' width='60' height='60' viewBox='0 0 60 60' className='fill-color' />
          </TopFile>
          <BottomFile>
            <First className='top loading-animation' />
            <First className='bottom loading-animation' />
          </BottomFile>
        </FirstFile>
        <FirstFile>
          <TopFile>
            <SVGIcon name='document-loading-icon' width='60' height='60' viewBox='0 0 60 60' className='fill-color' />
          </TopFile>
          <BottomFile>
            <First className='top loading-animation' />
            <First className='bottom loading-animation' />
          </BottomFile>
        </FirstFile>
        <FirstFile>
          <TopFile>
            <SVGIcon name='image-loading-icon' width='60' height='60' viewBox='0 0 60 60' className='fill-color' />
          </TopFile>
          <BottomFile>
            <First className='top loading-animation' />
            <First className='bottom loading-animation' />
          </BottomFile>
        </FirstFile>
        <FirstFile>
          <TopFile>
            <SVGIcon name='pdf-loading-icon' width='60' height='60' viewBox='0 0 60 60' className='fill-color' />
          </TopFile>
          <BottomFile>
            <First className='top loading-animation' />
            <First className='bottom loading-animation' />
          </BottomFile>
        </FirstFile>
      </FileCards>
    </Files>
  );
};

export default CustomerFilesLoading;
